import { INode } from 'shared/types/tree'
import * as React from 'react'

interface NodeContentUpdate {
  findAffectedNodes: (tree: INode) => INode[]
  convertContent: (content: string) => string | null
  updateNodes: (...node: INode[]) => Promise<void>
}

const emptyContext: NodeContentUpdate = {
  findAffectedNodes: () => [],
  convertContent: () => null,
  updateNodes: () => Promise.resolve(),
}

export const NodeContentUpdateContext =
  React.createContext<NodeContentUpdate>(emptyContext)
